import Project, { RawProject } from '../Model/Project';

const parseProject = (project: RawProject): Project => {
	return (project as unknown) as Project;
};

export default parseProject;
